var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,23H23V13.5a.5.5,0,0,0-.5-.5H20v-.5a.5.5,0,0,0-1,0V13h-.5a.5.5,0,0,0-.5.5V23H17V4.5a.5.5,0,0,0-.5-.5H14V2.5a.5.5,0,0,0-.5-.5H13V.5a.5.5,0,0,0-1,0V2H10.5a.5.5,0,0,0-.5.5V4H7.5a.5.5,0,0,0-.5.5V23H6V13.5a.5.5,0,0,0-.5-.5H5v-.5a.5.5,0,0,0-1,0V13H1.5a.5.5,0,0,0-.5.5V23H.5a.5.5,0,0,0,0,1h23a.5.5,0,0,0,0-1ZM11,3h2V4H11ZM2,23V14H5v9Zm6,0V5h8V23Zm11,0V14h3v9ZM15,7.5a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,7.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,10.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,13.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,16.5Zm0,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,15,19.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.bc41e9f3c105a6f93d75e995ff56a4e2.svg";
export { ForwardRef as ReactComponent };